import React from 'react';
import { Gift } from 'lucide-react';
import { Input } from '@/components/ui/input';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '@/components/ui/card';
import { Switch } from '@/components/ui/switch';
import { Label } from '@/components/ui/label';

export const ReferralSettings = ({ settings, updateSetting }) => (
  <Card>
    <CardHeader>
      <CardTitle className="flex items-center gap-2">
        <Gift className="h-5 w-5 text-[#fb6402]" />
        Referral Program
      </CardTitle>
      <CardDescription>Configure the referral discount system</CardDescription>
    </CardHeader>
    <CardContent className="space-y-4">
      <div className="flex items-center justify-between">
        <Label htmlFor="referral-enabled">Enable Referral Program</Label>
        <Switch id="referral-enabled" checked={settings?.referral_program_enabled} onCheckedChange={(v) => updateSetting('referral_program_enabled', v)} />
      </div>
      <div className="space-y-2">
        <Label>Referee discount (new customer) %</Label>
        <Input type="number" value={settings?.referral_discount_percent || 10} onChange={(e) => updateSetting('referral_discount_percent', parseFloat(e.target.value))} min="0" max="100" />
        <p className="text-xs text-gray-500">Discount given to the new customer using a referral code</p>
      </div>
      <div className="space-y-2">
        <Label>Referrer reward %</Label>
        <Input type="number" value={settings?.referrer_reward_percent || 5} onChange={(e) => updateSetting('referrer_reward_percent', parseFloat(e.target.value))} min="0" max="100" />
        <p className="text-xs text-gray-500">Discount/credit given to the person who referred</p>
      </div>
      <div className="space-y-2">
        <Label>Max referral uses per customer</Label>
        <Input type="number" value={settings?.max_referral_uses_per_customer || 3} onChange={(e) => updateSetting('max_referral_uses_per_customer', parseInt(e.target.value))} min="1" />
      </div>
    </CardContent>
  </Card>
);
